<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="text-left">
          <h3>
            <router-link to="/agenda">Agenda</router-link> » 
            {{currWeekText}}
            <span class="spancalendar">
              <i v-if="!showCalendar" @click="showCalendar=true" class="glyphicon glyphicon-calendar"></i>
              <Calendario v-if="showCalendar" @pickWeek="setWeek" class="calendario"></Calendario>
            </span>
            <span class="pull-right ferias" @click="showFerias()">
              Férias <i class="glyphicon glyphicon-time"></i>
            </span>
          </h3>
        </div>
      </div>
    </div>
    <div class="col-sm-12 week" v-if="week.length">
      <div v-for="day in week" :class="day.s === 0 || day.s === 6? 'col-sm-1' : 'col-sm-2'">
        <h2 :class="today === day.yyyymmdd? 'bg-primary' : ''">{{day.d}}</h2>
        <small>{{weekNames[day.s]}}</small>
        <hr>
        <span v-for="compromisso in tasks[day.yyyymmdd]">
          <small>
            <cite>{{compromisso.razao.toUpperCase()}}</cite>
            <span class="label label-default">{{compromisso.fantasia}}</span>
          </small>
          <b>{{compromisso.hora}}</b> <small>{{compromisso.funcionarionome}}</small>
          <i @click="select4edit(compromisso.cod)" class="glyphicon glyphicon-pencil"></i><br>
          <small v-if="compromisso.endcidade!==''">{{compromisso.endcidade}}</small>
          <small v-else>{{compromisso.cobcidade}}</small>
          <hr>
        </span>
        <button @click.prevent="addNewWithDate(day.yyyymmdd)" class="btn btn-xs btn-primary">+ Adicionar</button>
      </div>
    </div>
  </div>
</template>

<script>
import Calendario from './Calendar.vue'

export default {
  name: '',
  components: {
    Calendario
  },
  data () {
    return {
      weekNames: ['DOM', 'SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁB'],
      showCalendar: false,
      currWeekText: '',
      week: [],
      tasks: {}
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getagenda.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.tasks = response.body
        },
        function (error) {
          console.log(error)
        }
      )
    },
    setWeek (aDay, zDay, week) {
      console.log(aDay + '-' + zDay)
      this.week = week
      this.currWeekText = this.normalizeDate(aDay) + ' a ' + this.normalizeDate(zDay)
      this.showCalendar = false
      this.load({'adate': aDay, 'zdate': zDay})
    },
    select4edit (cod) {
      this.$router.push({path: `/agenda/u/${cod}`})
    },
    addNewWithDate (dt) {
      this.$root.globalAgeFormDt = dt
      this.$router.push({path: '/clientes/sup'})
    },
    normalizeDate (dt) {
      return dt.substring(6, 8) + '/' + dt.substring(4, 6) + '/' + dt.substring(2, 4)
    },
    showFerias () {
      this.$router.push({path: '/ferias'})
    }
  },
  created: function () {
    this.today = new Date().toISOString().slice(0, 10).replace(/-/g, '')
  }
}
</script>

<style scoped>
  .calendario {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
  }
  h3 span {
    position: relative;
  }
  .week {
    border: 1px solid #ccc;
  }
  .week div:first-child, .week div:last-child {
    color: #c00;
  }
  .week div:not(:last-child) {
    height: 100%;
  }
  .week div h2 {
    margin: 10px 10px 0px 10px;
  }
  .week div span {
    display: block;
    text-align: left;
  }
  .label-default {
    padding: 5px;
  }
  hr {
    margin: 0px 0px 10x 0px;
  }
  .ferias {
    cursor: pointer;
  }
  @media (max-width: 499px){
    .spancalendar {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AgeRelWeek.vue